import config from "./player/config";
import Player from 'player/player';
import image from 'utils/image';
import utils from 'utils/utils';
import Domain from 'player/model/domain';
import HomadAds from 'player/playback/ads/homad';

const SVP = {};
SVP.Player = Player;
SVP.Player.version = config.version;

// by default antiadblock is turned off
Object.defineProperty(SVP.Player, 'defaults', {
    get: function() {
        return this.__defaults || {};
    },
    set: function(value) {
        // if params are not object then
        // override and force to object
        if(value !== Object(value)) {
            value = {};
        }

        Object.defineProperty(SVP.Player, '__defaults', {
            value: value,
            enumerable: false,
            configurable: false,
            writable: false
        });
    }
});

const initialize = () => {
    image.initialize(utils.extend(config.images, {
        getPixelRatio: utils.device.getPixelRatio
    }));

    Domain.initialize(location.hostname);

// load homad only for desktop
    if (utils.device.getDeviceType() === 'desktop' && SVP.Player.defaults.aab === true) {
        HomadAds.initialize();
    }
};

export default SVP;
export { initialize };